import { Badge } from 'react-bootstrap';
import { Variant } from 'react-bootstrap/esm/types';

import { OrderStatusEnum } from 'src/models/GalenData/Order.model';

import useUiTranslation from 'src/hooks/useUiTranslation';

interface OrderStatusBadgeProps {
  status: OrderStatusEnum;
}

const OrderStatusBadge = ({ status }: OrderStatusBadgeProps) => {
  const { tCommon } = useUiTranslation();

  const statusConfig: Record<
    OrderStatusEnum,
    { color: Variant; label: string }
  > = {
    [OrderStatusEnum.OPEN]: { color: 'success', label: status },
    [OrderStatusEnum.PENDING]: { color: 'info', label: status },
    [OrderStatusEnum.COMPLETE]: { color: 'primary', label: status },
    [OrderStatusEnum.CLOSED]: { color: 'warning', label: status },
    [OrderStatusEnum.EXPIRED]: { color: 'danger', label: status },
  };

  const { color, label } = statusConfig[status];

  return (
    <Badge pill bg={color}>
      {tCommon(`orderFields.orderStatusEnum.${label}`)}
    </Badge>
  );
};

export default OrderStatusBadge;
